module.exports = __webpack_public_path__ + "img/f.fa5b6c94.jpg";